import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './AdmissionTest.scss';

const MARKING_SCHEME = [
  { label: 'Correct Answer', value: '+4', mod: 'correct' },
  { label: 'Wrong Answer',   value: '-1', mod: 'wrong'   },
  { label: 'Unanswered',     value: '0',  mod: 'skip'    },
];

const INSTRUCTIONS = [
  { icon: '🔒', text: 'Do not refresh or close the browser during the exam'       },
  { icon: '🚫', text: 'Once submitted, you cannot retake the exam'                 },
  { icon: '🔢', text: 'Use the Question Navigator panel to jump between questions' },
  { icon: '⏱',  text: 'Timer starts as soon as you click Start Exam'              },
  { icon: '📝', text: 'All questions are multiple choice with single correct answer'},
  { icon: '📊', text: 'Your result will be shown immediately after submission'     },
];

const AdmissionTestInstructions = ({ history, location }) => {
  const session = location?.state || {
    student_name: 'Rahul Kumar', admission_test: 'NEET Mock Test 1',
    total_questions: 10, duration_minutes: 30
  };

  const handleStartExam = () =>
    history.push({ pathname: '/admission-test-exam', state: session });

  return (
    <div className="sudent_exam_block">
      <div className="at-header"><h6>🎓 Rizee — Admission Test</h6></div>

      <Container className="py-4" style={{ maxWidth: 700 }}>

        <div className="schedule_exams mb-4">
          <Card className="single-card">
            <Card.Body className="single-card-body">
              <Row className="align-items-center">
                <Col xs="auto">
                  <div className="at-instructions__avatar">🎓</div>
                </Col>
                <Col>
                  <h6 className="at-instructions__student-name">{session.student_name}</h6>
                  <p className="at-instructions__exam-name">{session.admission_test}</p>
                </Col>
                <Col xs="auto">
                  <ul className="list-inline mb-0">
                    {[
                      { val: session.total_questions,     label: 'Questions' },
                      { val: session.duration_minutes,    label: 'Mins'      },
                    ].map((item, i) => (
                      <li key={i} className="list-inline-item text-center px-3 at-instructions__stat-item">
                        <div>{item.val}</div>
                        <div className="at-instructions__stat-label">{item.label}</div>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>

        <Card>
          <Card.Header className="at-instructions__card-header">
            <h6>📋 Read Before Starting</h6>
          </Card.Header>

          <Card.Body className="p-0">
            <div className="create_custom_timeline px-3 py-2">
              {INSTRUCTIONS.map((item, idx) => (
                <div key={idx} className="at-instructions__item d-flex align-items-center mb-2">
                  <span className="item-icon">{item.icon}</span>
                  <span className="item-text">{item.text}</span>
                </div>
              ))}
            </div>
          </Card.Body>

          <Card.Footer className="text-center p-3">
            <button className="btn btn-lg w-100 at-instructions__btn-start" onClick={handleStartExam}>
              ✅ I Understand, Start Exam
            </button>
          </Card.Footer>
        </Card>

      </Container>
    </div>
  );
};

export default AdmissionTestInstructions;
